import { gql } from '@apollo/client';

export const ALL_INDICATOR_PERIODS = gql`
  query AllIndicatorPeriods {
    indicatorPeriods: allIndicatorPeriods {
      id
      name
    }
  }
`;
